<template>
    <div>
        <Dashboard></Dashboard>
        <DashboardModals></DashboardModals>
    </div>
</template>

<script>
import DASHBOARD_STORE from "./store/dashboard.module";

export default {
    components: {
        Dashboard: () => import("./Dashboard"),
        DashboardModals: () => import("./partials/DashboardModals")
    },
    mounted() {
        console.log({ DASHBOARD_STORE })
    },
    beforeDestroy() {
        console.log("befor destroy")
        DASHBOARD_STORE.dispatch("resetState");
    },
    destroyed() {
        console.log("destroy")
    }
    
}
</script>